import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CartService } from 'src/app/services/cart.service';
import { BrowserStorageService } from 'src/app/services/storage.service';
import { __APP_STORAGE_CART__ } from 'src/app/intefaces/const';
import { Router } from '@angular/router';
import { AuthorizationService } from 'src/app/services/authorization.service';

@Component({
  selector: 'app-cart-handle',
  templateUrl: './cart-handle.component.html',
  styleUrls: ['./cart-handle.component.scss']
})
export class CartHandleComponent implements OnInit {
  private cartObserver: Subscription;
  public displayAddedToCart: boolean = false;
  public note: any;
  public visibleErrorCart: boolean = false;
  public selectedCurrency;
  public _width = '50vw';

  constructor(
    private cartService: CartService,
    private browserStorageService: BrowserStorageService,
    private router: Router,
    private auth: AuthorizationService
  ) {
    this.displayAddedToCart = false;
    this.visibleErrorCart = false;
    this.selectedCurrency = this.browserStorageService.get("_currency");

    if(window.innerWidth <= 576) {
        this._width = '98vw';
    }
  }


  ngOnInit(): void {
    this.initCartObserver();
    if (this.auth.isLogin()) {
      this.initCart();
    }
  }


  public goToCart() {
    this.router.navigate(['/koszyk']);
    this.visibleErrorCart = false;
    this.displayAddedToCart = false;

  }

  private initCartObserver() {
    this.cartObserver = this.cartService.listenCart().subscribe(data => {
      this.note = data;
      this.add(data);
    });
  }
  

  private initCart() {
    this.cartService.quantity().subscribe(d => {
      this.cartService.changeQuantity({ count: d.data });
    });
  }

  private add(data) {
    if (this.browserStorageService.get("_token")) {
      this.storeItem(data);
    } else {
      this.addToLocalStorage(data);
    }
  }

  private addToLocalStorage(data) {
    let cart: Array<any> = JSON.parse(this.browserStorageService.get(__APP_STORAGE_CART__)) || [];
    if (!this.isLocalStorageDuplicated(cart, data)) {
      cart.push(data);
      this.browserStorageService.set(__APP_STORAGE_CART__, JSON.stringify(cart));
      this.displayAddedToCart = true;
      this.cartService.changeQuantity({ count: cart.length });
    } else {
      this.visibleErrorCart = true;
    }
  }

  private isLocalStorageDuplicated(cart, item) {
    if (cart != null) {
      const items = cart.filter(c => c.id == item.id);
      if (items.length > 0) {
        return true;
      }
    }

    return false;
  }

  private storeItem(cart) {
    this.displayAddedToCart = true;
    this.cartService.storeCart(cart).subscribe(data => {
      this.cartService.changeQuantity({ count: data.data.quantity });
    },
      error => console.log("Err"));
  }

  ngOnDestroy(): void {
    if (this.cartObserver) {
      this.cartObserver.unsubscribe();
    }
  }

}
